import { createContext, useContext } from 'react';
import { useValue } from '../hali/index.js';

const context = createContext('hali');

export const Provider = context.Provider;

export default function useLab(key) {
  const ctx = useContext(context);
  
  if (!ctx) throw `unable to locate context "${ctx}"`;
  
  if (key === undefined) return ctx;
  if (!ctx[key]) throw `atom is required for key: "${key}" | ${ctx}`;

  return useValue(ctx[key]);
};